import { render, staticRenderFns } from "./NotificationAppointmentRequested.vue?vue&type=template&id=4726205b&scoped=true&"
import script from "./NotificationAppointmentRequested.vue?vue&type=script&lang=ts&"
export * from "./NotificationAppointmentRequested.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationAppointmentRequested.vue?vue&type=style&index=0&id=4726205b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4726205b",
  null
  
)

export default component.exports